import React from 'react';
import PropTypes from 'prop-types';

import { Container, Form, Icon, Button, Checkbox, Message, Header} from 'semantic-ui-react';

const Login = props => {
    let errorMessage;
    if (props.error) {
        const content = Array.isArray(props.error) ? props.error.map((e, index) => (<div key={index}>{`${e}`}</div>)) : props.error;
        errorMessage = (<Message error header="Authentication Failed" content={content} />);
    }
    return (
        <Container>
            <Form onSubmit={props.onSubmit} loading={props.loading} error>
                <Header as="h1" textAlign="center" content="Account Log In" />
                {errorMessage}
                
                <Form.Field inline>
                    <Icon name="user" size="big" />
                    <input name="username" placeholder="Username or Email Address" onChange={props.onChange} type="email" />
                </Form.Field>
                <Form.Field inline>
                    <Icon name="lock"  size="big"/>
                    <input name="password" type="password" placeholder="Password" onChange={props.onChange} />
                </Form.Field>
                <Form.Field inline>
                    <Icon size="big" />
                    <Checkbox name="rememberMe" label="Remember Me" onChange={props.onChange} />
                </Form.Field>
                <Form.Field>
                    <Button basic fluid type="submit">LOG IN</Button>
                </Form.Field>
                {props.children}
            </Form>
        </Container>
    );
};

Login.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    children: PropTypes.array,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ])
};

export default Login;